var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projects---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Explore_-projects-90",
    transform: "translate(-1416.000000, -818.000000)",
    stroke: "#7AEACD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-10",
    transform: "translate(1410.000000, 813.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(6.583333, 5.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: 1.65,
    cx: 13.9895833,
    cy: 14.1666667,
    rx: 13.1645833,
    ry: 13.3416667
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeWidth: 2.31,
    strokeLinecap: "round",
    points: "7.27786335 14.7893291 11.5431324 19.108589 19.9158735 10.6298638"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompleted);
export default __webpack_public_path__ + "static/media/ic_completed.23bd0bfa3921b550a21cae60cfffb26b.svg";
export { ForwardRef as ReactComponent };